import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { AuthorizedRequestArg } from '../signin/auth';
import * as authFetch from '../signin/authFetch';
import { Checklist } from './types';

interface ChecklistsState {
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  list: Array<Checklist>;
};

interface ListChecklistsRequest {
  listChecklists: object;
}

interface ListChecklistsResponse {
  checklists: Array<Checklist>
}

export const listChecklists = createAsyncThunk('goals/listChecklists', async (arg: AuthorizedRequestArg, { dispatch }) => {
  try {
    const response = await authFetch.post<ListChecklistsRequest, ListChecklistsResponse>(
      `${process.env.REACT_APP_SERVER_ROOT}/Goals`,
      {
        'listChecklists': {},
      },
      arg.authToken,
      dispatch
    )
    return response.data?.checklists || [];
  } catch (err) {
    console.log('Error', err);
  }
});

export const checklistsSlice = createSlice({
  name: 'checklists',
  initialState: {
    list: [],
    status: 'idle',
    error: null,
  } as ChecklistsState,
  reducers: {
  },
  extraReducers: builder => {
    builder.addCase(listChecklists.pending, (state, action) => {
      state.status = 'loading';
      state.error = null;
    });
    builder.addCase(listChecklists.fulfilled, (state, action) => {
      state.status = 'succeeded';
      state.error = null;
      state.list = action.payload || [];
    });
    builder.addCase(listChecklists.rejected, (state, action) => {
      state.status = 'failed';
      console.log('Error', action.error.message)
      state.error = action.error.message || null;
    });
  }
});

export const selectAllChecklists = (state: RootState) =>
  state.checklists.list;

export default checklistsSlice.reducer